import { RsoPage } from "@/features/rso/pages/Rso";

const Rso = () => {
  return <RsoPage />;
};

export default Rso;
